var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _circle2, _circle3, _circle4, _circle5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1022,
    viewBox: "0 0 1440 1022",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M314.287 454.35C314.287 524.483 371.141 581.337 441.274 581.337L441.274 581.337L441.274 656.979C329.365 656.979 238.645 566.259 238.645 454.35L314.287 454.35Z",
    fill: "#575759"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1240.63 47.642C1170.5 47.642 1113.64 104.496 1113.64 174.629L1113.64 174.629L1038 174.629C1038 62.72 1128.72 -28 1240.63 -28L1240.63 47.642Z",
    fill: "#575759"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M483.716 405.258C483.716 293.349 392.996 202.629 281.087 202.629C169.179 202.629 78.4585 293.349 78.4586 405.258L154.101 405.258C154.101 335.125 210.955 278.271 281.087 278.271C351.22 278.271 408.074 335.125 408.074 405.258L483.716 405.258Z",
    fill: "#575759"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M908.7 202.629C908.7 90.7202 817.98 8.75872e-05 706.071 8.26955e-05C594.162 7.78038e-05 503.442 90.7201 503.442 202.629C503.442 314.538 594.162 405.258 706.071 405.258L706.071 329.616C635.938 329.616 579.084 272.762 579.084 202.629C579.084 132.496 635.938 75.6421 706.071 75.6421C776.204 75.6421 833.058 132.496 833.058 202.629L908.7 202.629Z",
    fill: "#575759"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M548.65 568.76C627.781 489.628 756.079 489.628 835.21 568.76C914.342 647.891 914.342 776.189 835.21 855.321C756.079 934.452 627.781 934.452 548.65 855.321C548.623 855.293 548.595 855.266 548.568 855.239L548.65 855.321L602.137 801.834C651.728 851.425 732.132 851.425 781.723 801.834C831.315 752.242 831.315 671.838 781.723 622.247C732.132 572.655 651.728 572.655 602.137 622.247L548.65 568.76Z",
    fill: "#575759"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M812.373 460.833L888.015 460.833C888.015 390.7 944.869 333.846 1015 333.846C1085.13 333.846 1141.99 390.7 1141.99 460.833L1217.63 460.833L1217.63 460.986C1217.63 460.935 1217.63 460.884 1217.63 460.833C1217.63 348.924 1126.91 258.204 1015 258.204C903.093 258.204 812.373 348.924 812.373 460.833Z",
    fill: "#575759"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1139.23 1021.48L1139.23 945.843C1069.1 945.843 1012.24 888.989 1012.24 818.856C1012.24 748.723 1069.1 691.869 1139.23 691.869L1139.23 616.227C1027.32 616.227 936.599 706.947 936.599 818.856C936.599 930.764 1027.32 1021.48 1139.23 1021.48Z",
    fill: "#575759"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M405.258 738.763L329.616 738.762C329.616 808.895 272.762 865.749 202.629 865.749C132.496 865.749 75.6421 808.895 75.6421 738.762L-8.85719e-06 738.763C-3.9655e-06 850.671 90.7201 941.391 202.629 941.391C314.538 941.391 405.258 850.671 405.258 738.763Z",
    fill: "#575759"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1240.6 684.767C1184.64 587.851 1217.85 463.925 1314.77 407.97L1352.59 473.478C1291.85 508.545 1271.04 586.209 1306.11 646.946L1306.11 646.946L1240.6 684.767Z",
    fill: "#575759"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 1388.95,
    cy: 410.058,
    r: 41.6811,
    transform: "rotate(105 1388.95 410.058)",
    fill: "#575759"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 78.8361,
    cy: 596.123,
    r: 41.6811,
    transform: "rotate(105 78.8361 596.123)",
    fill: "#575759"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 100.085,
    cy: 123.737,
    r: 41.6811,
    transform: "rotate(105 100.085 123.737)",
    fill: "#575759"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 1247.54,
    cy: 847.844,
    r: 41.6811,
    transform: "rotate(105 1247.54 847.844)",
    fill: "#575759"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 1227.05,
    cy: 145.049,
    r: 41.6811,
    transform: "rotate(105 1227.05 145.049)",
    fill: "#575759"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.6aa3ed29c10b511f2f29281cf5af672c.svg";
export { ForwardRef as ReactComponent };